import AngelouPortrait from 'assets/portraits/Angelou.png';
import BowiePortrait from 'assets/portraits/Bowie.png';
import DickensonPortrait from 'assets/portraits/Dickenson.png';
import FitzgeraldPortrait from 'assets/portraits/Fitzgerald.png';
import HeadPortrait from 'assets/portraits/Head.png';
import HemmingwayPortrait from 'assets/portraits/Hemmingway.png';
import JobsPortrait from 'assets/portraits/Jobs.png';
import KingPortrait from 'assets/portraits/King.png';
import LeePortrait from 'assets/portraits/Lee.png';
import LincolnPortrait from 'assets/portraits/Lincoln.png';

export const Hemmingway = {
  owner: "Ernest Hemmingway",
  address: "0x42612aA30994c6D20cf327e73eba7CF69c187d6B",
  image: HemmingwayPortrait
};
export const Bowie = {
  owner: "David Bowie",
  address: "0x30e1a3CC069120E28e0125b4d92E99BD9359AE2A",
  image: BowiePortrait
};
export const Fitzgerald = {
  owner: "F Scott Fitzgerald",
  address: "0xDD66D1c3a35C0a121fe953B31438c273035792f5",
  image: FitzgeraldPortrait
};
export const King = {
  owner: "Martin Luther King Jr",
  address: "0x73BD37217B8806805104cD3b13D39e03Ec51B3a0",
  image: KingPortrait
};
export const Lee = {
  owner: "Harper Lee",
  address: "0x24984dfa3D454bed549a9e8e3470895B2aBd2B43",
  image: LeePortrait
};
export const Angelou = {
  owner: "Maya Angelou",
  address: "0x4fb80f7F855C3ef4e28F386c141d758e9014C4AC",
  image: AngelouPortrait
};
export const Lincoln = {
  owner: "Abraham Lincoln",
  address: "0x2Cb2D60dd338710B7313fB57383AE4b50b36F104",
  image: LincolnPortrait
};
export const Jobs = {
  owner: "Steve Jobs",
  address: "0xE49960a34baEAEa97509880Ce507fEc807A1C7B6",
  image: JobsPortrait
};
export const Head = {
  owner: "Edith Head",
  address: "0x132DB3d1dDaeDf33f7673C47C846e954d18Eb418",
  image: HeadPortrait
};
export const Dickenson = {
  owner: "Emily Dickenson",
  address: "0x62F2d2404A451d37bD694d97f5Ae5a0379D8eF55",
  image: DickensonPortrait
};

const ACCOUNTS = [
  Angelou, Bowie, Dickenson, Fitzgerald, Head, Hemmingway, Jobs, King, Lee, Lincoln
];

export default ACCOUNTS;
